// import React, { useState, useEffect, MouseEvent } from 'react';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import { teal } from '@mui/material/colors';
// import { Button, IconButton } from '@mui/material';
// import { useNavigate, useParams } from 'react-router-dom';
// import { Product } from '../../../types/productTypes';
// import { useAppDispatch } from '../../../Redux Toolkit/Store';
// import CloseIcon from '@mui/icons-material/Close';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { addProductToWishlist } from '../../../Redux Toolkit/Customer/WishlistSlice';

// interface ProductCardProps {
//     item: Product;
// }

// const WishlistProductCard: React.FC<ProductCardProps> = ({ item }) => {
//     const [currentImage, setCurrentImage] = useState(0);
//     const [isHovered, setIsHovered] = useState(false);
//     const [isFavorite, setIsFavorite] = useState(false);
//     const navigate = useNavigate();
//     const dispatch = useAppDispatch();

//     const handleIconClick = (e:MouseEvent) => {
//         setIsFavorite((prev) => !prev);
//         if(item.id)
//         dispatch(addProductToWishlist({productId:item.id}))
//     };



//     return (
//         <div className='w-60 relative '>
//             <div
//                 className="w-full"
//             >

//                 <img
//                     className=" object-top w-full"
//                     src={item.images[0]}
//                     alt={`product-${item.title}`}

//                 />



//             </div>
//             <div className='pt-3 space-y-1  rounded-md '>
//                 <div className=' space-y '>

//                     <p className=''>{item.title}</p>

//                 </div>
//                 <div className=' flex items-center gap-3 '>
//                     <span className='font-semibold text-gray-800'> ₹{item.sellingPrice}</span>
//                     <span className='text thin-line-through text-gray-400 '>₹{item.mrpPrice}</span>
//                     <span className='text-[#00927c] font-semibold'>{item.discountPercent}% off</span>
//                 </div>



//             </div>

// <div className='absolute top-1 right-1'>

//      <button
//      onClick={handleIconClick}
//       >
//  <CloseIcon className='cursor-pointer bg-white rounded-full p-1' sx={{ color: teal[500],fontSize:"2rem"  }} />
//      </button>

// </div>

//         </div>
//     );
// };



// export default WishlistProductCard


import React, { MouseEvent } from "react";
import { Heart, ShoppingBag, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Product } from "../../../types/productTypes";
import { useAppDispatch } from "../../../Redux Toolkit/Store";
import {
    addProductToWishlist,
    getWishlistByUserId,
} from "../../../Redux Toolkit/Customer/WishlistSlice";
import { addItemToCart } from "../../../Redux Toolkit/Customer/CartSlice";

interface ProductCardProps {
    item: Product;
}

const WishlistProductCard: React.FC<ProductCardProps> = ({ item }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleRemoveFromWishlist = (e: MouseEvent) => {
        e.stopPropagation();

        if (!item.id) return;

        dispatch(addProductToWishlist({ productId: item.id })).then(() => {
            dispatch(getWishlistByUserId());
        });
    };

    const handleMoveToCart = (e: MouseEvent) => {
        e.stopPropagation();

        if (!item.id) return;

        dispatch(
            addItemToCart({
                jwt: localStorage.getItem("jwt"),
                request: {
                    productId: item.id,
                    size: "FREE",
                    quantity: 1,
                },
            })
        );

        dispatch(addProductToWishlist({ productId: item.id })).then(() => {
            dispatch(getWishlistByUserId());
        });
    };

    const handleProductClick = () => {
        navigate(`/product-details/${item.category?.categoryId}/${item.id}`);
    };

    return (
        <div className="w-60 relative rounded-xl border border-gray-200 bg-white p-3 shadow-sm">
            <div
                onClick={handleProductClick}
                className="cursor-pointer w-full h-[220px] overflow-hidden rounded-lg bg-gray-100"
            >
                <img
                    className="w-full h-full object-cover object-center"
                    src={item.images?.[0]}
                    alt={`product-${item.title}`}
                />
            </div>

            <div className="pt-3 space-y-2">
                <div className="flex justify-between gap-2">
                    <p
                        onClick={handleProductClick}
                        className="line-clamp-2 cursor-pointer text-sm font-medium text-gray-900 hover:text-primary-color"
                    >
                        {item.title}
                    </p>

                    <Heart
                        size={19}
                        className="shrink-0 text-primary-color fill-primary-color"
                    />
                </div>

                <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold text-gray-900">
                        ₹{item.sellingPrice}
                    </span>

                    {item.mrpPrice && (
                        <span className="text-sm text-gray-400 line-through">
                            ₹{item.mrpPrice}
                        </span>
                    )}

                    {item.discountPercent !== undefined && (
                        <span className="text-sm font-semibold text-[#00927c]">
                            {item.discountPercent}% off
                        </span>
                    )}
                </div>

                <p
                    className={`text-sm ${item.in_stock === false ? "text-red-500" : "text-green-600"
                        }`}
                >
                    {item.in_stock === false ? "Out of Stock" : "In Stock"}
                </p>

                <div className="flex items-center gap-2 pt-1">
                    <button
                        onClick={handleMoveToCart}
                        disabled={item.in_stock === false}
                        className="flex flex-1 items-center justify-center gap-2 rounded-lg border border-primary-color px-3 py-2 text-sm font-medium text-primary-color hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        <ShoppingBag size={16} />
                        Move to Cart
                    </button>

                    <button
                        onClick={handleRemoveFromWishlist}
                        className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 hover:bg-gray-100"
                    >
                        <Trash2 size={17} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WishlistProductCard;